export default {"src":"https://s.sylndr.com/c-e456acf/_next/static/media/greenArrowAnimate.2342f2fa.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};